module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av686-72e0fd38246bad89c8dede17fdbcd29e.jpg";